import React, { useState } from "react";
import "./signup.css";
import { SignupAccount } from "./signup-account";
import { SignupAdditional } from "./signup-additional";
import { Stepper, Step, StepLabel } from "@material-ui/core";
import { SignupJoinFamily } from "./signup-join-family";

export const Signup = () => {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <>
      {activeStep === 0 && <SignupAccount setActiveStep={setActiveStep} />}
      {activeStep === 1 && <SignupAdditional setActiveStep={setActiveStep} />}
      {activeStep === 2 && <SignupJoinFamily />}

      <Stepper id="signup-progress" activeStep={activeStep}>
        <Step>
          <StepLabel>Create an account</StepLabel>
        </Step>
        <Step>
          <StepLabel>Add additional details</StepLabel>
        </Step>
        <Step>
          <StepLabel>Join/Create a family!</StepLabel>
        </Step>
      </Stepper>
    </>
  );
};
